import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'linescape-journal-of-commerce-technology',
  template: require('./linescape-journal-of-commerce-technology.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-journal-of-commerce-technology.scss')]
})
export class LinescapeJournalOfCommerceComponent extends BlogPage {
  title = "Sailing Schedule Data Improves Visibility and Efficiency - Linescape";
  description = "Leading Sailing Schedule data provider refreshes its website for easier use and more targeted information.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-journal-of-commerce-technology/linescape-journal-of-commerce-technology.ts